import { ArraySerializer, Field, Model, PrimitiveSerializer, Type, } from 'serialize-ts';
import { ProductImage } from '~app/modules/image-carousel/models';
import { Category } from '~app/modules/generic/models';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';
import { Attribute, Offer, ProductAttributeDetails, SortedBestOffers } from '~app/modules/product/models';
import { Brand } from '~app/modules/product/models/brand.model';


@Model()
export class Product {
  @Field()
  id: string;

  @Field()
  name: string;

  @Field()
  description: string;

  @Field()
  descriptionLong: string;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(ProductImage)))
  images: ProductImage[];

  @Field()
  bestOffer: Offer;

  @Field()
  hiddenOffersCount: number;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Offer)))
  offers: Offer[];

  @Field()
  category: string;

  @Field()
  quantity?: number;

  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  keyFeatures: string[];

  @Field()
  manufacturer: string;

  @Field()
  brand: Brand;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Attribute)))
  attributes: Attribute[];

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(ProductAttributeDetails)))
  productDetails: ProductAttributeDetails[];

  @Field()
  mid: string;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Category)))
  breadcrumbs: Category[];

  @Field()
  @Type(new ModelMetadataSerializer(Category))
  breadcrumbsFull?: Category;

  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  tags?: string[];

  @Field()
  pimCategoryId?: string;

  @Field()
  hasPromotion: boolean;

  @Field()
  gtin?: string;

  @Field()
  sortedBestOffers?: SortedBestOffers;

  @Field()
  mpn?: string;

  @Field()
  qtyTooltip?: boolean;

  @Field()
  addingToCart? : boolean;

  @Field()
  loading? : boolean;

  @Field()
  EECLabel? : string;

  @Field()
  notAvailableReason? : number | null;

}
